<template>
  <div
    v-ripple
    :class="[
      'profile-avatar',
      { 'hide-profile-avatar': !mobile },
      { 'd-md-none': mobile },
    ]"
    @click="showProfileDrawer"
  >
    <template v-if="mobile">
      <v-avatar
        v-if="!user || !user.image"
        color="#FF9100"
        class="menu-avatar mr-2"
        size="30"
      >
        <font-awesome-icon color="#ffffff" icon="user" />
      </v-avatar>
      <v-avatar
        v-else
        color="#FF9100"
        class="mr-2"
        size="50"
      >
        <img :src="user.image" alt="user-avatar" />
      </v-avatar>
    </template>
    <template v-else>
      <avatar :user="user" :border="false" class="header-avatar" />
      <span class="d-none d-xl-inline">{{ getUserName }}</span>
    </template>
  </div>
</template>

<script>
  import Avatar from '@/components/administrator/work-shift/staff/Avatar.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'ProfileAvatar',
    components: { Avatar },
    props: {
      mobile: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState({
        user: (state) => state.auth.user || {},
      }),
      getUserName () {
        return this.user ? this.user.name : '–'
      },
    },
    methods: {
      goToProfile () {
        this.$router.push('/profile')
      },
      showProfileDrawer () {
        this.$store.commit('app/showProfileDrawer')
      },
    },
  }
</script>

<style scoped lang="less">
.profile-avatar {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.media-lg({
  .hide-profile-avatar {
    display: none;
  }
});

.media-xl({
  .header-avatar {
    margin-right: 15px;
  }
});
</style>
